/**
 * Fear & Greed sentiment types.
 * Used as a lightweight psychological layer — never the primary signal.
 */

export type SentimentBucket =
  | 'extreme_fear' | 'fear' | 'neutral' | 'greed' | 'extreme_greed';

export interface SentimentData {
  /** 0–100 raw index value */
  value: number;
  /** Human-readable bucket */
  bucket: SentimentBucket;
  /** Display label */
  label: string;
  /** Timestamp of last update */
  timestamp: number;
}

export const SENTIMENT_LABELS: Record<SentimentBucket, string> = {
  extreme_fear: 'Extreme Fear',
  fear: 'Fear',
  neutral: 'Neutral',
  greed: 'Greed',
  extreme_greed: 'Extreme Greed',
};

export function classifySentiment(value: number): SentimentBucket {
  if (value <= 20) return 'extreme_fear';
  if (value <= 40) return 'fear';
  if (value <= 60) return 'neutral';
  if (value <= 80) return 'greed';
  return 'extreme_greed';
}

/** Normalize 0–100 index to -1 (extreme fear) to +1 (extreme greed) */
export function sentimentToSignal(value: number): number {
  return (value - 50) / 50; // -1 to +1
}

export const DEFAULT_SENTIMENT: SentimentData = {
  value: 50,
  bucket: 'neutral',
  label: 'Neutral',
  timestamp: 0,
};
